import { Box, Flex } from '@mantine/core'
import Image from 'next/image'
import React, { memo, useEffect, useRef, useState } from 'react'

import { createTradingViewWidgetScriptForStock } from '@/app/[locale]/price/[slug]/_components/CoinLineChart/components/TradingViewChart/utils'
import { useStockContext } from '@/app/[locale]/price/stocks/[symbol]/_contexts/StockContext'

import placeholderChart from '../StockLineChart/placeholder_price_chart.webp'
import { CHART_HEIGHT } from '../StockLineChart/utils'

function TradingViewWidget() {
  const container = useRef<HTMLDivElement>(null)
  const hasLoaded = useRef(false)
  const [tradingViewWidgetScriptLoaded, settradingViewWidgetScriptLoaded] = useState(false)
  const { stock } = useStockContext()

  useEffect(() => {
    if (hasLoaded.current || !container.current) return
    const script = createTradingViewWidgetScriptForStock(stock)
    script.onload = () => {
      settradingViewWidgetScriptLoaded(true)
    }
    container.current.appendChild(script)
    hasLoaded.current = true
  }, [])

  return (
    <Flex h={CHART_HEIGHT} w={'100%'} pos={'relative'}>
      <Box className="tradingview-widget-container" ref={container}>
        <Box className="tradingview-widget-container__widget"></Box>
      </Box>
      {!tradingViewWidgetScriptLoaded && (
        <Box pos={'absolute'} w={'100%'} h={'100%'} style={{ borderRadius: 8, overflow: 'hidden' }}>
          <Image
            src={placeholderChart}
            alt="Loading chart"
            fill
            style={{ objectFit: 'contain' }}
            priority
          />
        </Box>
      )}
    </Flex>
  )
}

export default memo(TradingViewWidget)
